const message6DisplayPropertyReducer = (state = {display:'none'}, action) => {
	switch(action.type){
	case 'MESSAGE6DISPLAY':	
		return action.payload;
	default:
		return state;
	}
}

export default message6DisplayPropertyReducer;